/**************
 Global
 ***************/

// url params
const urlParams = new URLSearchParams(window.location.search);

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // pixels
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (e) {
        // skip
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

/**************
 Reviews
 ***************/
document.querySelectorAll('.reviews')?.forEach(async (element) => {
    let product = parseInt(element.dataset.product);

    const baseUrl = `https://api-cdn.yotpo.com/products/lcHNp9yEe79YLiBy2LflWUtwJdrnqINwU4AcBalu/${product}/bottomline`;

    // get request to baseURL
    await fetch(baseUrl)
        .then(response => response.json())
        .then(data => {
            let score = data.response.bottomline.average_score;
            let reviews = data.response.bottomline.total_reviews;

            // insert average score
            element.querySelector('.reviewsRating').textContent = score + " stars";

            // insert total reviews
            element.querySelector('.reviewsNum').textContent = `FROM ${reviews} REVIEWS`;
        });
});

/**************
 Sample Video
 ***************/

// close event
document.querySelectorAll(".sample")?.forEach(function (element) {
    element.addEventListener("close", function () {

        // check if there's a video playing and pause it
        element.querySelector(".sampleBtnVid")?.pause();
        element.querySelector(".sampleBtnPlay")?.classList.remove("active");

        document.querySelector("body").classList.remove("noScroll");
    });
});

// open sample event listener
document.querySelectorAll(".openSample")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

//close gallery event listener
document.querySelectorAll(".closeSample")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();

    });
});

document.querySelectorAll(".sample")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.sample")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

// play button listener (if they click the video)
document.querySelectorAll(".sampleBtn")?.forEach(function (element) {
    element.addEventListener("click", function () {

        // hide play button
        this.querySelector(".sampleBtnPlay").classList.add("active");

        //pause all other videos if they're playing and show their play button
        document.querySelectorAll(".sampleBtn").forEach(function (other_video) {
            if ((other_video !== element) && (!other_video.querySelector(".sampleBtnVid").paused)) {
                other_video.querySelector(".sampleBtnVid").pause();
                other_video.querySelector(".sampleBtnPlay").classList.remove("active");
            }
        });

        // if this video is paused, play it, otherwise pause it (toggles play/pause)
        if (this.querySelector(".sampleBtnVid").paused) {
            this.querySelector(".sampleBtnVid").play();
            this.querySelector(".sampleBtnPlay").classList.add("active");
        } else {
            this.querySelector(".sampleBtnVid").pause();
            this.querySelector(".sampleBtnPlay").classList.remove("active");
        }

    });
});


// returns a checkout URL with the current cart items
function getCheckoutURL() {
    if (cart.items.length === 0) {
        console.log("Cart is empty")
        return;
    }

    // initial checkout URL - clear cart first
    let url = "https://" + Shopify.shop + "/cart/clear?return_to=/cart/add?";
    cart.items.forEach(function (item, index) {
        // check for selling plan
        if (item.selling_plan_allocation) {
            url += `items[${index}][quantity]=${item.quantity}%26items[${index}][selling_plan]=${item.selling_plan_allocation.selling_plan.id}%26items[${index}][id]=${item.variant_id}%26`;
        } else {
            url += `items[${index}][quantity]=${item.quantity}%26items[${index}][id]=${item.variant_id}%26`;
        }

    })
    url += "return_to=/checkout"
    console.log(url)
}


// global atc
document.querySelectorAll(`a[href^="#atc-"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // get the variant id
        let variantID = this.getAttribute("href").replace("#atc-", "");

        // add to their cart
        await addProduct({
            id: variantID,
            quantity: 1
        });

        await openCart();
    })
});